import { Translation } from '@ps/web-shared-components';
import { isEmpty } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';

import Redirect from '@swf/components/Redirect/Redirect';
import { select } from '@swf/core/store';

import useMapGameData from '../../hooks/useMapGameData';
import { useHomeGamesWidget } from '../../model';
import { TileType } from '../../types/common';
import { handleShowingBrandIconElement } from '../../utils/isPokerSiteLabel';
import NoData from '../NoData/NoData';
import PokerGameTileContainer from '../PokerGameTileContainer/PokerGameTileContainer';

import {
  TXTWCL_Cash_Games_from_your_clubs_wil_ELL,
  TXTWCL_No_Cash_Games_to_Show
} from './CashGames.messages.json';
import styles from './CashGames.scss';
import NoDataIcon from './assets/no-data-card.svg';
import NoPokerDataIcon from './assets/no-poker-no-data-card.svg';

const CashGames: React.FC = () => {
  const { widgetSelect } = useHomeGamesWidget();
  const clubs = useSelector(widgetSelect.clubs);
  const isCashGamesActive = useSelector(widgetSelect.isCashGameActive);
  const tables = useSelector(widgetSelect.tables);
  const noClubs = isEmpty(clubs);
  const noGames = isEmpty(tables);
  const { mappedTables } = useMapGameData({ shouldMapTables: true });
  const isExternalPartnerSite = useSelector(select.cms.isExternalPartnerSite);

  if (noClubs) {
    return <Redirect alias="homeGamesClubs" />;
  }

  return (
    <div className={styles.container}>
      {noGames ? (
        <NoData
          icon={handleShowingBrandIconElement(
            isExternalPartnerSite,
            <NoPokerDataIcon />,
            <NoDataIcon />
          )}
          primaryText={<Translation {...TXTWCL_No_Cash_Games_to_Show} />}
          secondaryText={<Translation {...TXTWCL_Cash_Games_from_your_clubs_wil_ELL} />}
        />
      ) : (
        <PokerGameTileContainer
          games={mappedTables}
          clubs={clubs}
          tileType={TileType.Cash}
          isCashGamesActive={isCashGamesActive}
        />
      )}
    </div>
  );
};

export default CashGames;
